<template>
  <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        {{
        $t("AUTH.GENERAL.NO_ACCOUNT")
        }}
      </span>&nbsp;&nbsp;
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'register' }"
      >{{ $t("AUTH.GENERAL.SIGNUP_BUTTON") }}</router-link>
    </div>

    <div class="login-form login-signin">
      <div class="text-center mb-5">
        <h3 class="font-size-h1">{{ $t("AUTH.LOGIN.TITLE") }}</h3>
      </div>
      <v-alert type="error" :value="hasError">{{ errorMessage }}</v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-text-field
          v-model="form.username"
          type="text"
          :rules="usernameRules"
          label="Номер телефона"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.password"
          type="password"
          :rules="passwordRules"
          label="Пароль"
          required
        ></v-text-field>
        <div class="d-flex align-center justify-space-between mt-5">
          <router-link :to="{name: 'restore'}">Забыли пароль?</router-link>
          <v-btn color="primary" @click="onSubmit" :loading="submitting">Вход</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "login",
  metaInfo: {
    title: "Авторизация",
  },
  data() {
    return {
      submitting: false,
      valid: true,
      hasError: false,
      errorMessage: null,
      form: {
        username: "",
        password: "",
      },
      usernameRules: [(v) => !!v || "не может быть пустым"],
      passwordRules: [(v) => !!v || "не может быть пустым"],
    };
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.hasError = false;
        this.$store.dispatch(LOGOUT);

        this.$store
          .dispatch(LOGIN, { role: process.env.VUE_APP_ROLE, ...this.form })
          .then(() => this.$router.push({ name: "root" }))
          .catch((response) => {
              this.hasError = true;
              this.errorMessage = response.data.errors.base.join(", ");
          })
          .finally(() => (this.submitting = false));
      }
    },
    goToRestore() {
      this.$router.push({ name: "restore" });
    },
  },
};
</script>
